import SimpleZip from "simplezip.js";
import axios from 'axios';

// == Download PNG image ==
export async function downloadImg(fileName: string, mint: string) {
    let blob = await getImageAsBlob(`https://dragon.eternaldragons.com/${mint}.png`);

    fileName = fileName.replace("♯", "#");
    download(blob, `${fileName}.png`);
}

// == Download PNG_WITH_FRAME image ==
export async function downloadImgWithFrame(fileName: string, mint: string) {
    let imgBlob = await getImageAsBlob(`https://dragon.eternaldragons.com/${mint}_framed.png`);

    fileName = fileName.replace("♯", "#");
    download(imgBlob, `${fileName} Framed.png`);
}

// == Download both PNG + PNG_WITH_FRAME images in ZIP ==
export async function downloadZipImgs(fileName: string, mint: string) {
    let imgBlob = await getImageAsBlob(`https://dragon.eternaldragons.com/${mint}.png`);
    let imgFrameBlob = await getImageAsBlob(`https://dragon.eternaldragons.com/${mint}_framed.png`);

    // We have problem with this char when in zip file so we change it!
    fileName = fileName.replace("♯", "#");

    var files = [
        { name: `${fileName}.png`, data: await imgBlob.arrayBuffer() },
        { name: `${fileName} Framed.png`, data: await imgFrameBlob.arrayBuffer() }
    ];

    var dataArrayBuff = SimpleZip.GenerateZipFrom(files);
    var blob = new Blob([dataArrayBuff]);

    download(blob, `${fileName}.zip`);
}

//
export function download(blob: Blob, fileName: string) {
    var url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

//
export async function getImageAsBlob(url: string) {
    let res = await axios.get(url, { responseType: 'blob' })
    return res.data;
}